<template>
  <div class="c-headline headline">
    <h2
      v-if="data.type === 2"
      v-html="data.content"
    ></h2>
    <h3
      v-if="data.type === 3"
      v-html="data.content"
    ></h3>
    <h4
      v-if="data.type === 4"
      v-html="data.content"
    ></h4>
  </div>
</template>

<script>
export default {
  name: 'AppHeadline',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.headline {
  text-align: center;

  h2 {
    font-family: $font-family-heading;
    font-size: 23px;
    letter-spacing: 5px;
    text-transform: uppercase;

    @include mq(ipadP) {
      font-size: 28px;
    }
  }

  h3 {
    font-family: $font-family-text;
    font-size: 20px;

    @include mq(ipadP) {
      font-size: 24px;
    }
  }

  h4 {
    font-family: $font-family-text;
    font-size: 17px;
    letter-spacing: 1px;

    @include mq(ipadP) {
      font-size: 20px;
    }
  }
}
</style>
